<template>
  <div class="view-magiclogin">
    <logo />
    <template v-if="!state.error">
      <p v-if="state.success == false">{{ $t("messages.autoLogin") }}</p>
    </template>
    <template v-else>
      <p class="message-error">{{ state.error }}</p>
      <router-link :to="{ name: 'login' }">
        {{ $t("labels.login") }}
      </router-link>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, onMounted } from "vue";
import Logo from "@core/ui/SimcisionLogo.vue";

import { useUser } from "@/api/user.store";
import { useRoute, useRouter } from "vue-router";

const props = defineProps<{
  uid: string;
  token: string;
  type?: string;
  relatedPk?: string;
}>();

const route = useRoute();
const router = useRouter();
const { loginWithToken } = useUser();

const state = reactive({
  error: "",
  success: false
});

const redirectPath = computed(() => {
  if (route.redirectedFrom) {
    return {
      path: route.redirectedFrom.path,
      params: route.redirectedFrom.params
    };
  }
  return {
    name: "models-explorer"
  };
});

onMounted(async () => {
  try {
    await loginWithToken(
      props.uid,
      props.token,
      props.type,
      props.relatedPk
    );
    state.success = true;
    await router.replace(redirectPath.value);
  } catch (e) {
    const error = e as Error;
    state.error = error.message;
    router.replace(redirectPath.value);
  }
});
</script>

<style>
.view-magiclogin {
  margin: auto;
  text-align: center;
}
</style>
